import { PageHeading } from "@/components/Layout/Parts";
import ImageToolMainForm from "./components/ImageToolMainForm";
import BackButton from "@/components/BackButton";
import Text from "@/components/Text";

const ImageToolCreate = () => {
  return (
    <>
      <Text $type="caption" $color="gray">
        BORED PANDA
      </Text>
      <PageHeading>Image Tool</PageHeading>
      <BackButton link="/general/image-tool/type/recents" />
      <ImageToolMainForm />
    </>
  );
};

export default ImageToolCreate;
